import styled from '@emotion/styled/macro';
import vars from '@variables';

export const StandardHrAtom = styled.hr`
  margin: 10px auto;
  width: 100%;
`;

// For dashed <hr>, we should disable one of the borders: bottom/top and style the other one
// OR we could have a full width div instead of <hr>
export const DashedHrAtom = styled.hr<{ color?: string }>`
  border-top: none !important;
  border-bottom: 1px dashed ${({ color }) => color || vars.coreDarkGrey};
`;
